import React, { useEffect, useState } from 'react';
import '../../../../scss/pages/Home/WeeklyContest/leaderBoard.scss';
import LeftArrow from '../../../../asset/svg/leftArrow.svg';
import RightArrow from '../../../../asset/svg/rightArrow.svg';
import { Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import PrizePoolOuter from '../../../../asset/svg/prizePoolOuter.svg'
import PrizePoolInner from '../../../../asset/svg/prizePoolInner.svg'
import { useNavigate, useLocation } from "react-router-dom";
import { HOME_PATH, LEADBOARD_HISTORY } from '../../../../utils/Constants';
import coinsWon from '../../../../asset/svg/coinsWon.svg'
import downArrow from '../../../../asset/svg/downArrow.svg';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useDispatch, useSelector } from 'react-redux'
import { GET_LEADERBOARD_LASTUPDATED, LEADERBOARD_TABLE_DATA } from '../../../../sagas/type';
import { getLocalStoreString } from '../../../../utils/Helper';
import { getDateWeek } from '../../../../components/common/DateTime/DateTime';

function leaderBoard() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch()
    const { leaderBoardTableDatas, leaderboardLastUpdatedData } = useSelector(mapStateToProps);
    const [itemToShow, setItemToShow] = useState(10);
    const [shownPage, setShownPage] = useState(0)

    const leaderBoardColumnData = [
        { field: 'rank', label: 'Rank' },
        { field: 'participants', label: 'Participants' },
        { field: 'targetAchieved', label: 'Target Achieved' },
        { field: 'coinsEarned', label: 'Coins Earned' },
    ]

    const prizePoolColumnData = [
        { field: 'rank', label: 'Rank' },
        { field: 'coins', label: 'Coins' },
    ]

    useEffect(() => {
        leaderBoardData();
        clevertapleaderboard();
    }, []);

    const clevertapleaderboard = () => {
        clevertap.spa = true
        clevertap.event.push("Weekly Contest");
    }

    useEffect(() => {
        getLeaderBoardLatestUpdateDate();
    }, [leaderBoardTableDatas])


    const leaderBoardData = () => {
        const leaderBoardId = location && location.state?.leaderBoardId
        dispatch({
            type: LEADERBOARD_TABLE_DATA,
            payload: { leaderBoardId, shownPage, itemToShow }
        })
    }

    const getLeaderBoardLatestUpdateDate = () => {
        const contestScoreBoardId = leaderBoardTableDatas?.scoreBoard?.id;
        const EmployeeCode = getLocalStoreString("EmployeeCode");

        dispatch({
            type: GET_LEADERBOARD_LASTUPDATED,
            payload: { contestScoreBoardId, EmployeeCode }
        })

    }

    const handleBack = () => {
        navigate(HOME_PATH)
    }

    const handleViewHistory = () => {
        navigate(LEADBOARD_HISTORY, { state: leaderBoardTableDatas && leaderBoardTableDatas.scoreBoard })
    }

    const handleViewMore = () => {
        setShownPage(shownPage + 1);
        setItemToShow(itemToShow + 10);
    }
    const handleViewLess = () => {
        setShownPage(shownPage - 1);
        setItemToShow(itemToShow - 10);
    }
    return (
        <div className='leaderBoard-container'>
            <div className='leaderBoard-container_header'>
                <img className='leaderBoard-container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                <span className='leaderBoard-container_header_content'>Weekly Contest</span>
            </div>
            <div className='leaderBoard-container_table-container'>
                <div className='leaderBoard-container_table-container_table1'>
                    <div className='leaderBoard-container_table-container_table1_heading'>
                        <div className='leaderBoard-container_table-container_table1_heading_title'>
                            <Typography className='leaderBoard-container_table-container_table1_heading_title_title1'>Leaderboard</Typography>&nbsp;&nbsp;
                            <Typography className='leaderBoard-container_table-container_table1_heading_title_title2' > Last Updated <span className='leaderBoard-container_table-container_table1_heading_title_title2_span-title' >{getDateWeek(leaderboardLastUpdatedData?.lastUpdatedTimestamp)}</span> </Typography>
                        </div>
                        <div className='leaderBoard-container_table-container_table1_heading_history' onClick={handleViewHistory}>See History &nbsp; <span><img onClick={handleViewHistory} className='leaderBoard-container_table-container_table1_heading_history_image' src={RightArrow} alt="" /></span></div>
                    </div>
                    <div className='leaderBoard-container_table-container_table1_tabledata'>
                        <TableContainer component={Paper}>
                            <Table aria-label="caption table">
                                <TableHead >
                                    <TableRow >
                                        {leaderBoardColumnData && leaderBoardColumnData.length > 0 && leaderBoardColumnData.map((head) => (
                                            <TableCell sx={{ color: 'gray', textAlign: 'center' }}>{head.label}</TableCell>))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {leaderBoardTableDatas && leaderBoardTableDatas.entities && leaderBoardTableDatas.entities.length > 0 && leaderBoardTableDatas.entities.slice(0, itemToShow).map((row) => (
                                        <TableRow key={row.name}>
                                            <TableCell sx={{ color: 'gray', textAlign: 'center' }}>
                                                {row.rank}
                                            </TableCell>
                                            <TableCell sx={{ color: 'white', textAlign: 'center' }}>{row.employeeName}</TableCell>
                                            <TableCell sx={{ color: 'gray', textAlign: 'center' }}>{row.displayScore}</TableCell>
                                            <TableCell sx={{ color: 'white', textAlign: 'center' }}><div style={{ display: "flex", textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}><img src={coinsWon} className='' alt='' /> &nbsp;&nbsp;{row.coins} </div></TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {leaderBoardTableDatas && leaderBoardTableDatas.entities && leaderBoardTableDatas.entities.length > 10 && <div className='leaderBoard-container_table-container_table1_tabledata_view-button-container'>
                            {itemToShow < leaderBoardTableDatas && leaderBoardTableDatas.entities.length && (
                                <button className='leaderBoard-container_table-container_table1_tabledata_view-button-container_button' onClick={handleViewMore}>View More
                                    &nbsp;&nbsp;  <img src={downArrow} alt='' />
                                </button>
                            )}
                            {itemToShow > 10 && <button className='leaderBoard-container_table-container_table1_tabledata_view-button-container_button' onClick={handleViewLess}>View Less
                                &nbsp; <KeyboardArrowUpIcon style={{ position: 'relative', top: ' 10px ' }} />
                            </button>}
                        </div>}
                    </div>
                </div>
                <div >
                    <div className='leaderBoard-container_table-container_table2'>
                        <div className='leaderBoard-container_table-container_table2_image-container1'><img className='leaderBoard-container_table-container_table2_image-container1_outer-image' src={PrizePoolOuter} alt="" /></div>
                        <div className='leaderBoard-container_table-container_table2_image-container2'><img className='leaderBoard-container_table-container_table2_image-container2_inner-image' src={PrizePoolInner} alt="" /></div>
                        <div className='leaderBoard-container_table-container_table2_table-content' >
                            <TableContainer component={Paper} >
                                <Table aria-label="caption table">
                                    <TableHead >
                                        <TableRow >
                                            {prizePoolColumnData && prizePoolColumnData.length > 0 && prizePoolColumnData.map((head) => (
                                                <TableCell sx={{ color: 'gray', textAlign: 'center' }}>{head.label}</TableCell>))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {leaderBoardTableDatas && leaderBoardTableDatas.entities && leaderBoardTableDatas.entities.length > 0 && leaderBoardTableDatas.entities.map((row) => (
                                            <TableRow key={row.name}>
                                                <TableCell sx={{ color: 'gray', textAlign: 'center' }}>{row.rank}</TableCell>
                                                <TableCell sx={{ color: 'white', textAlign: 'center' }}><div style={{ display: "flex", textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}><img src={coinsWon} className='' alt='' />&nbsp;&nbsp;{row.coins}</div></TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                    <div className='leaderBoard-container_table-container_list-content'>
                        <ul>
                            <li>Actual prize may change if there is a tie at any winning ranks.</li>
                            <li>Only <bold className='leaderBoard-container_table-container_list-content_listbold'> 50% of coins </bold> won will be given incase quality score is less than <bold className='leaderBoard-container_table-container_list-content_listbold'>98 %</bold></li>
                            <li>Coins will be distributed postreview of quality scores</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        leaderBoardTableDatas: state.dashboardConfig.leaderBoardTableDatas,
        leaderboardLastUpdatedData: state.dashboardConfig.leaderboardLastUpdatedData,

    }
}

export default leaderBoard;